import styled, { css } from "styled-components";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
var TagAtm = styled.p.withConfig({
  componentId: "sc-140m7k1-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["", ";display:inline-flex;padding:", " ", ";border-radius:", ";background:", ";text-align:center;"], cssTextAtm({
    typography: "nano2_u",
    color: "secondary"
  }), space(0.5), space(2), getBorderRadius(theme, "huge"), getColor(theme, "backgroundDarkLight"));
});
export default TagAtm;